import Vue from 'vue'
import mixpanel from 'mixpanel-browser'

export default ({ app }, inject) => {
  const MIXPANEL_TOKEN = process.env.MIXPANEL_TOKEN
  const MIXPANEL_QONTAK_ONE_TOKEN = process.env.MIXPANEL_QONTAK_ONE_TOKEN

  mixpanel.init(
    MIXPANEL_TOKEN,
    {
      debug: process.env.NODE_ENV !== 'production',
      ignore_dnt: process.env.NODE_ENV !== 'production',
    },
    'mixpanelChat'
  )

  mixpanel.init(
    MIXPANEL_QONTAK_ONE_TOKEN,
    {
      debug: process.env.NODE_ENV !== 'production',
      ignore_dnt: process.env.NODE_ENV !== 'production',
    },
    'mixpanelQontakOne'
  )

  const mixpanelChat = mixpanel.mixpanelChat
  const mixpanelQontakOne = mixpanel.mixpanelQontakOne

  mixpanelChat.register({
    'App Version': app.$config.appversion,
  })

  mixpanelQontakOne.register({
    'App Version': app.$config.appversion,
  })

  inject('mixpanelChat', mixpanelChat)
  inject('mixpanelQontakOne', mixpanelQontakOne)

  Vue.use(mixpanel)
}
